// Dependencies
import React, { Component } from 'react';
import RegistrationFormStepTitleComponent from '../form-step-title/form-step-title';

// Primereact imports
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './step-11.scss';

// Utils
import { COMPANY_DATA, FORM_FIELD_ADDRESS_LINE, FORM_FIELD_CITY, FORM_FIELD_CP3, FORM_FIELD_CP4, FORM_FIELD_EMAIL, FORM_STEP_11_STATE, PAYMENT_METHOD_CC, PAYMENT_METHOD_MB, PAYMENT_METHOD_MBWAY, PAYMENT_TYPE_REGISTRATION_INITIAL, PERSONAL_COMPANY_DATA, PERSONAL_DATA, REGISTRATION_STATE_REVISION, STEP_STATE_SUBMITTED, STEP_STATE_VALIDATION_ERROR } from '../../../common/constants';

// Redux
import { connect } from 'react-redux';
import { updateFormStep, updateStep11State } from '../../../redux/actions/form';
import { RadioButton } from 'primereact/radiobutton';
import { WORLD_LIST } from '../../../common/lists/countries';
import { Dropdown } from 'primereact/dropdown';
import { getCreditCardFormConfig } from '../../../common/utils/credit-card-utils';
import FinancialService from '../../../redux/services/finance';
import { validateNIF } from '../../../common/utils/validation-utils';
import { updateGeneratedPaymentRef } from '../../../redux/actions/quote';
import { getFormValue } from '../../../common/utils/form-utils';

class RegistrationFormStep11Component extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // Invoice data management
            selectedInvoiceData: PERSONAL_DATA,
            selectedPaymentMethod: PAYMENT_METHOD_MB,
            mobilePhoneNumber: "",
            mobilePhoneNumberPrefix: "",
            companyEntity: "",
            companyNipc: "",
            companyNipcCountry: null,
            showCardForm: false,
            // Validation flags
            validMobilePhoneNumberPrefix: true,
            validMobilePhoneNumber: true,
            validCompanyEntity: true,
            validCompanyNipc: true,
            validCompanyEntity: true,
        }
    }

    updateFormComponent(column, value) {
        this.setState({
            [column]: value
        })
    }

    updateInvoiceData(invoiceData) {
        this.setState({
            selectedInvoiceData: invoiceData
        });
    }

    updatePaymentMethod(paymentMethod) {
        this.setState({
            selectedPaymentMethod: paymentMethod
        });
    }

    validateForm() {
        let validEntity = (this.state.selectedInvoiceData === PERSONAL_DATA);
        let validNipc = (this.state.selectedInvoiceData === PERSONAL_DATA);
        let validMobilePhoneNumber = true;
        let validMobilePhoneNumberPrefix = true;

        if(this.state.selectedInvoiceData === PERSONAL_COMPANY_DATA || this.state.selectedInvoiceData === COMPANY_DATA) {
            validEntity = (this.state.companyEntity !== null && this.state.companyEntity !== "");
            validNipc = (this.state.companyNipc !== null && this.state.companyNipc !== "") && validateNIF(this.state.companyNipc);

            this.setState({
                validCompanyEntity: validEntity,
                validCompanyNipc: validNipc
            });
        }

        if(this.state.selectedPaymentMethod === PAYMENT_METHOD_MBWAY) {
            validMobilePhoneNumber = this.state.mobilePhoneNumber !== null && this.state.mobilePhoneNumber !== "";
            validMobilePhoneNumberPrefix = this.state.mobilePhoneNumberPrefix !== "";

            this.setState({
                validMobilePhoneNumber: validMobilePhoneNumber,
                validMobilePhoneNumberPrefix: validMobilePhoneNumberPrefix
            });
        }

        return validEntity && validNipc && validMobilePhoneNumber && validMobilePhoneNumberPrefix;
    }

    submitStep() {
        if(this.validateForm()) {
            this.props.updateStep11State(STEP_STATE_SUBMITTED);

            this.props.updateFormStep(1, 
                [
                    { key: FORM_STEP_11_STATE, value: STEP_STATE_SUBMITTED }
                ],
                () => this.props.onSubmit());
        }
        else {
            this.props.updateStep11State(STEP_STATE_VALIDATION_ERROR);

            this.props.updateFormStep(1, 
                [
                    { key: FORM_STEP_11_STATE, value: STEP_STATE_VALIDATION_ERROR }
                ],
                () => {});
        }
    }

    generateCreditCardCheckout() {
        FinancialService.generateCreditCardCheckout({
            paymentType: PAYMENT_TYPE_REGISTRATION_INITIAL,
            email: getFormValue(FORM_FIELD_EMAIL, this.props.formFields)
        })
        .then((response) => {
            const script1 = document.createElement("script");
            script1.innerHTML = getCreditCardFormConfig(getFormValue(FORM_FIELD_CITY, this.props.formFields),
                getFormValue(FORM_FIELD_CP4, this.props.formFields),
                getFormValue(FORM_FIELD_CP3, this.props.formFields),
                getFormValue(FORM_FIELD_ADDRESS_LINE, this.props.formFields),
                "", 
                this.props.t("checkout.messages.invalid-holder"));
            script1.async = true;
            
            const script2 = document.createElement("script");
            script2.src = process.env.REACT_APP_SIBS_WIDGET_URL + response.checkout.id;
            script2.async = true;

            document.body.appendChild(script1);
            document.body.appendChild(script2);

            this.setState({
                showCardForm: true
            });

            this.props.updateGeneratedPaymentRef(response.paymentRef);
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("checkout.messages.error"), life: 3000 });
        });
    }

    render() {
        return (
            <>
                <div id="data-container" className="card p-fluid mgt-20">
                    <div className="grid">
                        <div className="col-12">
                            <div className="grid mgt-10">
                                <RegistrationFormStepTitleComponent title={this.props.t("registration-form.step-11.title")}
                                                                    subtitles={[ this.props.t("registration-form.step-11.subtitle-1") ]} />
                                <div className='col-12 t-align-left mgt-20'><b>{this.props.t("checkout.form.payment-data")}</b></div>
                                <div className='col-3'>
                                    <div>
                                        <div className="field-radiobutton">
                                            <RadioButton inputId="ref-mb" name="payment-method" value={PAYMENT_METHOD_MB} onChange={(e) => this.updatePaymentMethod(PAYMENT_METHOD_MB)} checked={this.state.selectedPaymentMethod === PAYMENT_METHOD_MB} />
                                            <label htmlFor="ref-mb">{this.props.t("quotes.dialog.payment-methods.mb")}</label>
                                        </div>
                                        <div className="field-radiobutton">
                                            <RadioButton inputId="cc" name="payment-method" value={PAYMENT_METHOD_CC} onChange={(e) => this.updatePaymentMethod(PAYMENT_METHOD_CC)} checked={this.state.selectedPaymentMethod === PAYMENT_METHOD_CC} />
                                            <label htmlFor="cc">{this.props.t("quotes.dialog.payment-methods.cc")}</label>
                                        </div>
                                        <div className="field-radiobutton">
                                            <RadioButton inputId="mb-way" name="payment-method" value={PAYMENT_METHOD_MBWAY} onChange={(e) => this.updatePaymentMethod(PAYMENT_METHOD_MBWAY)} checked={this.state.selectedPaymentMethod === PAYMENT_METHOD_MBWAY} />
                                            <label htmlFor="mb-way">{this.props.t("quotes.dialog.payment-methods.mbway")}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-9 t-align-left'>
                                {
                                    this.state.selectedPaymentMethod === PAYMENT_METHOD_MBWAY ?
                                        <div className='grid'>
                                            <div className='col-12 t-align-left'>
                                                <p>{this.props.t("quotes.dialog.mbway")}</p>
                                            </div> 
                                            <div className='col-4 t-align-left'>
                                                <label className='mgr-10' htmlFor="mobile-number-prefix">{this.props.t("quotes.dialog.mobile-number-prefix")}</label>
                                                <InputText autocomplete="off" value={this.state.mobilePhoneNumberPrefix} className={!this.state.validMobilePhoneNumberPrefix ? "p-invalid" : null} id="mobile-number-prefix" type="number" style={{width:"80px"}} onChange={(evt) => this.setState({mobilePhoneNumberPrefix: evt.target.value})} />
                                                { this.state.validMobilePhoneNumberPrefix ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                            </div> 
                                            <div className='col-8 t-align-left'>
                                                <label className='mgr-10' htmlFor="mobile-number">{this.props.t("quotes.dialog.mobile-number")}</label>
                                                <InputText autocomplete="off" value={this.state.mobilePhoneNumber} className={!this.state.validMobilePhoneNumber ? "p-invalid" : null} id="mobile-number" type="number" onChange={(evt) => this.setState({mobilePhoneNumber: evt.target.value})} />
                                                { this.state.validMobilePhoneNumber ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                            </div> 
                                        </div>
                                        : <div className='col-12 t-align-left'></div>
                                }
                                </div>
                                <div className='col-12 t-align-left mgt-10'>
                                    <b className='mgb-20'>{this.props.t("quotes.dialog.invoice-data")}</b>
                                    <div className="field-radiobutton mgt-10">
                                        <RadioButton inputId="personal-data" name="invoice-data" value={PERSONAL_DATA} onChange={(e) => this.updateInvoiceData(PERSONAL_DATA)} checked={this.state.selectedInvoiceData === PERSONAL_DATA} />
                                        <label htmlFor="personal-data">{this.props.t("quotes.dialog.my-invoice-data")}<b>{this.props.t("quotes.dialog.name-nif").replace("{0}", "Pedro Flores").replace("{1}", "232560129")}</b></label>
                                    </div>
                                    <div className="field-radiobutton">
                                        <RadioButton inputId="company-data" name="invoice-data" value={PERSONAL_COMPANY_DATA} onChange={(e) => this.updateInvoiceData(PERSONAL_COMPANY_DATA)} checked={this.state.selectedInvoiceData === PERSONAL_COMPANY_DATA} />
                                        <label htmlFor="company-data">{this.props.t("quotes.dialog.personal-company-invoice-data")}</label>
                                    </div>
                                    <div className="field-radiobutton">
                                        <RadioButton inputId="company-data" name="invoice-data" value={COMPANY_DATA} onChange={(e) => this.updateInvoiceData(COMPANY_DATA)} checked={this.state.selectedInvoiceData === COMPANY_DATA} />
                                        <label htmlFor="company-data">{this.props.t("quotes.dialog.other-company-invoice-data")}</label>
                                    </div>
                                </div> 
                                {
                                    this.state.selectedInvoiceData === PERSONAL_COMPANY_DATA || this.state.selectedInvoiceData === COMPANY_DATA ?
                                        <>
                                            <div className='col-6 t-align-left'>
                                                <label  htmlFor="company-entity">{this.props.t("quotes.dialog.company-entity")}</label>
                                                <InputText value={this.state.companyEntity} className={!this.state.validCompanyEntity ? "p-invalid" : null} id="company-entity" style={{width: "350px", marginLeft:"10px"}} type="text" onChange={(evt) => this.setState({companyEntity: evt.target.value})} />
                                                { this.state.validCompanyEntity ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                            </div>
                                            <div className='col-3 t-align-left'> 
                                                <label htmlFor="company-nipc">{this.props.t("quotes.dialog.company-nipc")}</label>
                                                <InputText value={this.state.companyNipc} className={!this.state.validCompanyNipc ? "p-invalid" : null} id="company-nipc" type="text" style={{width:"100px", marginLeft:"10px"}} onChange={(evt) => this.setState({companyNipc: evt.target.value})} />
                                                { this.state.validCompanyNipc ? null : <p><small className="p-error">{this.props.t("quotes.messages.invalid-nif")}</small></p>  }
                                            </div> 
                                            <div className='col-3 t-align-left'>
                                                <label htmlFor="nipc-country">{this.props.t("quotes.dialog.company-nipc-country")}</label>
                                                <Dropdown id="nipc-country" style={{width:"150px", marginLeft:"10px"}} value={this.state.companyNipcCountry} options={WORLD_LIST} optionLabel="name" onChange={(evt) => this.setState({ companyNipcCountry: evt.value })}></Dropdown>
                                            </div>
                                        </>
                                        : null
                                } 
                                {
                                    this.state.showCardForm ? 
                                        <div className="col-12 t-align-left mgt-10">
                                            <form action={process.env.REACT_APP_BASE_ADDRESS + "/checkout"} className="paymentWidgets" data-brands="VISA MASTER AMEX"></form>
                                        </div> 
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION ?
                        <div className="mgt-20">
                            <div className="grid">
                                <div className="col-6 t-align-left mgt-10">
                                    <Button label={this.props.t("general.back")} severity="info" raised outlined onClick={(evt) => this.props.onBack()} />
                                </div> 
                                <div className="col-6 t-align-right mgt-10">
                                    <Button label={this.props.t("general.submit")} severity="success" raised onClick={(evt) => this.state.selectedPaymentMethod === PAYMENT_METHOD_CC ? this.generateCreditCardCheckout() : this.submitStep()} />
                                </div> 
                            </div>
                        </div>
                        : null
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        registrationState: state.authentication.registrationState,
        formFields: state.form.formFields,
        language: state.profile.language
    } 
};
  
const mapDispatchToProps = (dispatch) => {
    return {
        updateFormStep: (stepFields) => { dispatch(updateFormStep(stepFields)) },
        updateStep11State: (state) => { dispatch(updateStep11State(state)) },
        updateGeneratedPaymentRef: (paymentRef) => { dispatch(updateGeneratedPaymentRef(paymentRef)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(RegistrationFormStep11Component));